<template>
    <div class="pcr-establishment-groups">
        <div class="tab-contextual-button">
            <el-tooltip placement="top" content="Ajouter un groupe" effect="light" :open-delay="300" v-if="$currentTreeNode.Rights.GrantLevel >= $grantLevel.administrator">
                <el-button @click="startAdd">
                    <i class="fa fa-group" aria-hidden="true"></i>
                    <i class="fa fa-plus" aria-hidden="true"></i>
                </el-button>
            </el-tooltip>
        </div>

        <el-input placeholder="Recherche" v-model="filterText" class="table-search"></el-input>
        <el-table ref="table" :data="searchFilteredGroups" stripe border :default-sort="{prop: 'GroupId', order: 'ascending'}" style="width: 100%" highlight-current-row @current-change="currentChange">
            <el-table-column prop="GroupId" label="Id" sortable width="80px"></el-table-column>
            <el-table-column prop="GroupName" label="Nom" sortable>
                <template slot-scope="scope">
                    {{scope.row.GroupName}}
                    <span class="label pull-right" :style="$getComputedColor(scope.row.GroupName)">{{scope.row.GroupName}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="UserCount" label="Nombre d'utilisateurs" sortable></el-table-column>
            <el-table-column label="Autorisation par defaut" sortable :render-header="renderAutorisationHeader">
                <template slot-scope="scope">
                    <pcr-grant-level-label :item="scope.row"></pcr-grant-level-label>
                </template>
            </el-table-column>
            <el-table-column label="" width="84px" class-name="cell-action" v-if="$currentTreeNode.Rights.GrantLevel >= $grantLevel.administrator">
                <template slot-scope="scope">
                    <el-dropdown trigger="click">
                        <el-button @click.stop>Actions <i class="fa fa-caret-down" aria-hidden="true"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <remove-group :group-id="scope.row.GroupId" :name="scope.row.GroupName" @on-remove="refresh()"></remove-group>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
        
        <el-dialog title="Ajouter un groupe" :visible.sync="showAddModal" size="small" :close-on-click-modal="false">
            <ck-form ref='ck-form' label-position="top">
                <el-row :gutter="12">
                    <el-col :span="24">
                        <ck-form-item label="Autorisation par defaut du groupe" :display="grantLevelFormatter(group)">
                            <el-select v-model="group.GrantLevel" placeholder="Select">
                                <el-option
                                v-for="item in grantLevels"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                            <ck-validator :validators="{ validator: $ckValidator.required, model: group.GrantLevel, trigger: 'change' }">
                                Veuillez indiquer le niveau d'autorisation
                            </ck-validator>
                        </ck-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="12">
                    <el-col :span="24">
                        <ck-form-item label="Nom" :display="group.GroupName">
                            <el-input v-model="group.GroupName" auto-complete="off" type="text"></el-input>
                            <ck-validator :validators="{ validator: $ckValidator.required, model: group.GroupName, trigger: 'change' }">
                                Veuillez indiquer le nom du groupe
                            </ck-validator>
                        </ck-form-item>
                    </el-col>
                </el-row>

                <div>
                    <div class="pull-right">
                        <el-button type="default" @click="cancelAdd" native-type="submit">Annuler</el-button>
                        <el-button type="primary" @click="endAdd" native-type="submit">Enregistrer</el-button>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </ck-form>
        </el-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
export default Vue.component('establishment-group-list', {
    props: {
        establishmentId: {
            default: () => 0
        }
    },
    data() {
        return {
            groups: [],
            
            showAddModal: false,
            group: {
                GroupName: '',
                GrantLevel: 0
            },
            grantLevels: [
                { value: 0, label: 'Aucune' }, 
                { value: 8, label: 'Contact' },
                { value: 16, label: 'Viewer' },
                { value: 64, label: 'Editeur' },
                { value: 112, label: 'Administrateur' }
            ],
            filterText: ''
        }
    },
    computed: {
        searchFilteredGroups() {
            if(!this.filterText) return this.groups;
            
            return _.filter(this.groups, (item) =>
            {
                return _.includes( this.$normalizeString(item.GroupId+''), this.filterText )
                    || _.includes( this.$normalizeString(item.GroupName), this.filterText );
            });
        }
    },
    mounted: function () {
        this.refresh();
        
        this.$root.$on('pcr_update_data', () => {
            this.refresh();
        })
    },
    methods: {
        refresh() {
            if (!this.refreshing) {
                this.refreshing = true;

                this.$http.get('/api/establishment/' + this.establishmentId + '/groups').then((response) => {
                    this.groups = response.data;
                    this.refreshing = false;
                });
            }
        },
        currentChange(row) {
            if(this.$getSelectedText()) 
            {
                this.$refs['table'].setCurrentRow();
                return;
            }
            
            //a group is like an establishment for the tree selection
            this.$router.push({ query: { establishmentId: row.GroupId } });
        },
        grantLevelFormatter(item) {
            return this.GrantLevelLabels[item.GrantLevel];
        },
        renderAutorisationHeader() {
            return (
                <el-tooltip placement="top" content="Autorisation obtenue par les utilisateurs ajoutés dans ce groupe" effect="light" open-delay={300}>
                    <span>Autorisation <i class="fa fa-question-circle pointer" aria-hidden="true"></i></span>
                </el-tooltip>
            );
        },
        cancelAdd() {
            this.showAddModal = false;
            this.group = {
                GroupName: ''
            };
        },
        startAdd() {
            this.showAddModal = true;
        },
        endAdd(e) {
            e.preventDefault();
            this.$refs['ck-form'].validate((valid) => {
                if (valid) {
                    this.$http.post('/api/establishment/' + this.establishmentId + '/group', this.group).then((response) => {
                        this.$swal({
                            type: 'success',
                            title: 'Enregistré',
                            text: 'Le groupe a bien été ajouté'
                        }).then(() => {

                        });

                        //reset form
                        this.cancelAdd();

                        this.$root.$emit('pcr_update_data');
                        this.$root.$emit('pcr_update_tree');
                    });
                }
                else {
                    this.$swal({
                        type: 'error',
                        title: 'Formulaire invalide',
                        html: 'Veuillez vérifier les informations du formulaire.'
                    });
                }
            });
        },
    },
    watch: {
        establishmentId(val) {
            if (val) {
                this.refresh();
            }
        }
    }
});
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/establishment/establishment-group-list.vue